import { combineReducers } from 'redux';

import invoices from './invoices';
import global from './global';
import accountDetails from './accountDetails';
import paymentMethods from './paymentMethods';
import userDetails from './userDetails';
import pricingPlan from './account/pricingPlan';
import users from './users';
import ssoConfiguration from './ssoConfiguration';
import twoFactorConfiguration from './twoFactorConfiguration';
import partnerAdAccounts from './partnerAdAccounts/partnerAdAccounts';
import historyEvents from './historyEvents';
import tracker from './tracker/tracker';
import partner from './partner/partner';
import userPermissions from './userPermissions/userPermissions';
import app from './app/app';

// Root reducer
export default combineReducers({
  app,
  userPermissions,
  invoices,
  global,
  accountDetails,
  paymentMethods,
  userDetails,
  pricingPlan,
  users,
  ssoConfiguration,
  tracker,
  twoFactorConfiguration,
  partner,
  partnerAdAccounts,
  historyEvents,
});
